module.exports = ".full-width {\n    width: 100%;\n  }"